// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"dad0e902","143":"4a02e334","192":"bb983ee4","295":"a209f125","349":"2e6f9252","351":"9956d63d","592":"2c2c7620","655":"ece7c2f2","813":"459e746b","866":"08b36b5e","927":"5138f20c","963":"86048b6b"}[chunkId] + ".chunk.js";
};